import { Empty, TableColumnsType } from "antd";
import React from "react";
import ReusableTable from "../../../../../../global components/Table/Table";
import ReusablePopover from "../../../../../../global components/Popover/ReuseablePopover";
import ActionsPopOver from "../ActionsPopOver";
import Elipses from "../../../../../../global components/Icons/Elipses";
import { PaginatedGetAssignedNumbersType } from "../../../../../../libs/Utils/Types/NumberManagement";
import dayjs from "dayjs";
import Unauthorised from "../../../../../../global components/Unauthorised";
import s from "./PhoneNumberTable.module.scss";
import clsx from "clsx";
type ColumnType = {
  number: string;
  serialNumber: number;
  key: string;
  user: string;
  country: string;
  assignedDate: string;
  status: string;
  actions: string;
};
type PropType = {
  data: PaginatedGetAssignedNumbersType["data"];
  isLoading: boolean;
  unauthorized: boolean | { title: string; message: string };
  mutate: () => void;
};
function PhoneNumberTable({ data, isLoading, unauthorized, mutate }: PropType) {
  const columns: TableColumnsType<ColumnType> = [
    {
      title: "S/N",
      key: "serialNumber",
      dataIndex: "serialNumber",
      render: (serialNumber: string) => <span>{serialNumber}</span>,
    },
    {
      title: "Number",
      key: "number",
      dataIndex: "number",
      render: (number: string) => <span>{number}</span>,
    },
    {
      title: "Current User",
      key: "user",
      dataIndex: "user",
      render: (user: string) => <span>{user}</span>,
    },
    {
      title: "Country",
      key: "country",
      dataIndex: "country",
      render: (country: string) => <span>{country}</span>,
    },
    {
      title: "Assigned date",
      key: "assignedDate",
      dataIndex: "assignedDate",
      render: (assignedDate: string) => <span>{assignedDate}</span>,
    },
    {
      title: "Status",
      key: "status",
      dataIndex: "status",
      render: (status: string) => (
        <span
          className={clsx(
            s.status,
            s.statusCell,
            status === "active"
              ? s.successful
              : status === "revoked" || status === "deleted"
                ? s.failed
                : s.pending,
          )}
        >
          {status.charAt(0).toUpperCase() + status.slice(1)}
        </span>
      ),
    },
    {
      title: "Actions",
      key: "actions",
      dataIndex: "actions",
      render: (
        actions: string,
        record: { key: string; status: string; number: string },
      ) => (
        <ReusablePopover
          trigger={"hover"}
          content={
            <ActionsPopOver
              mutate={mutate}
              id={record.key}
              number={record.number}
              status={record.status}
            />
          }
        >
          {" "}
          <Elipses height={24} width={18} />
        </ReusablePopover>
      ),
    },
  ];

  const dataSource: ColumnType[] = data.map((item, index) => ({
    actions: "",
    assignedDate: item.assignedAt
      ? dayjs.utc(item.assignedAt).local().format("DD/MM/YYYY")
      : "-",
    country: item.country,
    key: item.id,
    number: item.phoneNo,
    serialNumber: index + 1,
    status: item.status,
    user: item.user ? item.user?.firstName + " " + item.user?.lastName : "N/A",
  }));
  return (
    <ReusableTable
      columns={columns}
      dataSource={dataSource}
      loading={isLoading}
      noDataComponent={
        unauthorized ? (
          typeof unauthorized === "boolean" ? (
            <Unauthorised />
          ) : (
            <Unauthorised error={unauthorized} />
          )
        ) : (
          <Empty />
        )
      }
    />
  );
}

export default PhoneNumberTable;
